import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../../commonComponent/ComingSoon';

function MaintenanceReport() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className=" p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">
            Housekeeping and Maintenance Management
          </h1>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/dashboard/core-modules/housekeeping-management')}
              className="btn "
            >
              Room Status and Cleaning
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/housekeeping-management/maintenance-report')
              }
              className="btn text-black font-bold"
            >
              Maintenance Requests
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/housekeeping-management/inventory-management')
              }
              className="btn"
            >
              Inventory Management
            </button>
          </div>
        </header>
        <ComingSoon />
      </div>
    </div>
  );
}

export default MaintenanceReport;
